<template>
  <div class="grid">
    <router-link
      v-if="to"
      :to="to"
      class="focus:outline-none cursor-pointer w-min text-white text-sm py-1 px-2 rounded-md bg-gray-500 hover:bg-gray-600 hover:shadow-lg flex items-center"
    >
      <i class="fas fa-arrow-left mr-2"></i>
      Kembali
    </router-link>
    <a
      v-else
      @click.prevent="$router.go(-1)"
      class="focus:outline-none cursor-pointer w-min text-white text-sm py-1 px-2 rounded-md bg-gray-500 hover:bg-gray-600 hover:shadow-lg flex items-center"
    >
      <i class="fas fa-arrow-left mr-2"></i>
      Kembali
    </a>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    to: {
      type: String,
      default: "",
    },
  },
});
</script>
